export enum AppointmentChecklistType {
  FILLED_FORM = "FILLED_FORM",
  CHECKED_IN = "CHECKED_IN",
  WITH_MA = "WITH_MA",
  MEASUREMENT_TAKEN = "MEASUREMENT_TAKEN",
  DOSE_TAKEN = "DOSE_TAKEN",
  WITH_PROVIDER = "WITH_PROVIDER",
  NOTE_TAKEN = "NOTE_TAKEN",
  PAYMENT_MADE = "PAYMENT_MADE",
  REQUEST_GFE = "REQUEST_GFE",
  PICTURE_TAKEN = "PICTURE_TAKEN",
  CARE_PLAN = "CARE_PLAN",
  // Configured per service like the steps above. Auto-completes when a
  // later-day appointment is booked on or after the visit's day.
  REBOOK = "REBOOK",
  // Ticked only by the system, when the visit's note is signed off.
  NOTE_SIGNED_OFF = "NOTE_SIGNED_OFF",
  // Ticks itself when a profile photo is saved for the patient, and starts
  // ticked when the patient already has one.
  PROFILE_PHOTO = "PROFILE_PHOTO",
}
